export default __webpack_public_path__ + "static/exp3-8087014221369db84fd238d8aed52f30.png";